export const OP_ADDRESSES = {
  ERC20: '0x4200000000000000000000000000000000000042',
  UNISWAP_POOL: '0x68f5c0a2de713a54991e01858fd27a3832401849',
} as const
